import { checkShouldUseMocks } from '@telialt/utils/src/envUtils';
import { MS_URL } from '@telialt/utils/src/microservices';

export const FULL_NAME_VALIDATION_PATTERN = /^\s*[A-Za-z\u00C0-\u017F'’\-]+(?:\s+[A-Za-z\u00C0-\u017F'’\-]+)+\s*$/;
export const FULL_NAME_MAX_LENGTH = 70;

export const API = {
    URL_POST_FEEDBACK: `${MS_URL}/api/v3/communications/feedback`,
};

if (checkShouldUseMocks({ shouldUseInTest: true })) {
    API.URL_POST_FEEDBACK = '/api/content/feedback';
}
